const INITIAL_STATE = {
  deliveryType: null,
  selectedBranch: 0,
  observation: "Nenhuma observação",
  shippingFleet: null,
  selectedShipping: 0,
  selectedPlate: 0,
  date: "",
  items: [],
  stepActive: 0,
  previousPage: '/criar-pedido',
  business: null,   
  vehicleData: null,  
  orderDetails: null,
  selectedEmailIndex: 0,
  setEmail: null,
  storesGroups: [],
  products: [],
  orderDraft: {
    loadedPage: false,
    applied: false,
    data: {},
    payload: {},
    response: {}
  },
  plates: {
    loadedPage: false,
    validated: false,
    pendencies: [],
    payload: {},
    response: {}
  },
  subsidized: {
    loadedPage: false,
    applied: false,
    data: {}
  },
  replacement: {
    loadedPage: false,
    applied: false,
    data: {},
    payload: {},
    response: {}
  },
  financialDiscount: {
    loadedPage: false,
    applied: false,
    data: {},
    payload: {},
    response: {},
  },
  paymentCondition: null,
  taxDelivery: null,
  salesConsultant: null,
  priceList: null,
  inicialOrderValue: 0,
};

export const Creators = {
  addDate: (date) => ({
    type: "ADD_DATE",
    date,
  }),
  resetLogistic: () => ({
    type: "LOGISTIC_DEFAULT",
  }),
};

export default function logisticReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case "SET_STEP_ACTIVE":
      return {
        ...state,
        stepActive: action.stepActive,
      };
    case "SET_PREVIOUS_PAGE":
      return {
        ...state,
        previousPage: action.previousPage,
      };
    case "SET_DELIVERY_TYPE":
      return {
        ...state,
        deliveryType: action.deliveryType
      };
    case "ADD_OBSERVATION_LOGISTIC":
      return {
        ...state,
        observation: action.observation,
      };
    case "SELECT_BRANCH_LOGISTIC":
      return {
        ...state,
        selectedBranch: action.selectedBranch,
      };
    case "SELECT_SHIPPING":
      return {
        ...state,
        selectedShipping: action.selectedShipping,
      };
    case "SELECT_PLATE":
      return {
        ...state,
        selectedPlate: action.selectedPlate,
      };
    case "SELECT_EMAIL_INDEX":
      return {
        ...state,
        selectedEmailIndex: action.selectedEmailIndex,
      };
    case "SELECT_EMAIL":
      return {
        ...state,
        selectedEmail: action.selectedEmail,
      };
    case "UPDATE_ITEMS":
      return {
        ...state,
        items: action.items,
      };
    case "SET_ORDER_DRAFT":
      return {
        ...state,
        orderDraft: {
          ...action.orderDraft,
          ...action.orderDraftData
        },
      };
    case "SET_SUBSIDIZED":
      return {
        ...state,
        subsidized: {
          ...state.subsidized,
          ...action.subsidizedData,
        }
      };
    case "SET_BUSINESS":
      return {
        ...state,
        business: action.business,
      }
    case "SET_VEHICLE_DATA":
      return {
        ...state,
        vehicleData: action.vehicleData,
      }    
    case "SET_PLATES":
      return {
        ...state,
        plates: {
          ...state.plates,
          ...action.platesData,
        },
      };
    case "SET_REPLACEMENT":
      return {
        ...state,
        replacement: {
          ...state.replacement,
          ...action.replacementData,
        },
      };
    case "SET_FINANCIAL_DISCOUNT":
      return {
        ...state,
        financialDiscount: {
          ...state.financialDiscount,
          ...action.financialDiscountData,
        },
      };
    case "SET_ORDER_DETAILS":
        return {
          ...state,
          orderDetails: action.orderDetails,
        };
    case "SET_STORES_GROUP":
      return {
        ...state,
        storesGroups: action.storesGroups,
      };
    case "ADD_DATE":
      return { ...state, date: action.date };
    case "DELETE_ITEM":
      return {
        ...state,
        items: state.items.filter((item) => item.id !== action.item.id),
      };
    case "ADD_PRODUCT_LOGISTIC":
      return { ...state, products: action.products };
    case "SET_ORDER_ITEMS":
      return {
        ...state,
        items: action.items
      }
    case "SET_PAYMENT_CONDITION":
      return {
        ...state,
        paymentCondition: action.paymentCondition
      }
    case "SET_TAX_DELIVERY":
      return {
        ...state,
        taxDelivery: action.taxDelivery
      }
    case "SET_SALES_CONSULTANT":
      return {
        ...state,
        salesConsultant: action.salesConsultant
      }
    case "SET_PRICE_LIST":
      return {
        ...state,
        priceList: action.priceList
      }
    case "SET_INITIAL_ORDER_VALUE":
      return {
        ...state,
        inicialOrderValue : action.inicialOrderValue
      }
    case "LOGISTIC_DEFAULT":
      return INITIAL_STATE;
    default:
      return state;
  }
}
